import { render } from "./MemberDashboard.vue?vue&type=template&id=4d229a90&scoped=true"
import script from "./MemberDashboard.vue?vue&type=script&lang=js"
export * from "./MemberDashboard.vue?vue&type=script&lang=js"

import "./MemberDashboard.vue?vue&type=style&index=0&id=4d229a90&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d229a90"]])

export default __exports__